<button class="rounded border-0 gradient-accent primary w-100 custom__button" (click)="onButtonClicked()">
    <div class="d-flex">
        <div class="flex-grow-1 flex-shrink-0">
            <ng-content></ng-content>
        </div>
        <fa-icon class="button-icon flex-shrink-1 flex-grow-0 pr-3" *ngIf="icon" [icon]="icon"></fa-icon>
    </div>
</button>